import { type postDataSort } from '@shared/all/domains/posts';

const getTimeBySort = (date: Date, sort: postDataSort | null): string => {
  const MS_IN_A_DAY = 86400000;
  const current = new Date();

  const elapsed = current.getTime() - date.getTime();

  const absElapsed = Math.abs(elapsed);
  const daysElapsed =
    absElapsed / 3600000 <= 24 ? 0 : Math.round(absElapsed / MS_IN_A_DAY);

  switch (sort) {
    case 'DAILY':
      if (daysElapsed === 0) return 'today';
      if (daysElapsed === 1) return 'yesterday';
      return `${daysElapsed} days ago`;
    case 'WEEKLY':
      const diffWeeks = Math.floor(daysElapsed / 7);
      if (diffWeeks === 0) return 'this week';
      if (diffWeeks === 1) return 'last week';
      return `${diffWeeks} weeks ago`;

    case 'MONTHLY':
      const diffMonths =
        (current.getFullYear() - date.getFullYear()) * 12 +
        (current.getMonth() - date.getMonth());
      if (diffMonths === 0) return 'this month';
      if (diffMonths === 1) return 'last month';
      return `${diffMonths} months ago`;

    default:
      return '';
  }
};

export default getTimeBySort;
